/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
import './src/styles/global.scss'
import './src/internationalization/i18n'
import { initPlausible } from '@foldland/nextjs-plausible'
import {
  createBeforeSendRedactor,
  DEFAULT_BOT_PATTERNS,
  DEFAULT_IGNORE_ERRORS,
  DEFAULT_SENSITIVE_PARAM_NAMES,
  initFaro,
} from '@foldland/vercel-observability/client'
import { initBotId } from 'botid/client/core'
import type { GatsbyBrowser } from 'gatsby'
import FaroRouteView from './src/components/FaroRouteView'

const OBSERVABILITY_PATTERN = /^.*\/api\/v1\/fl-observability$/
const INSIGHTS_PATTERN = /^.*\/api\/v1\/fl-insights$/

export const onClientEntry = () => {
  initBotId({
    protect: [
      {
        path: '/api/contact-submit',
        method: 'POST',
      },
    ],
  })

  initPlausible({
    // biome-ignore lint/style/useNamingConvention: upstream issue
    NEXT_PUBLIC_PLAUSIBLE_PROXY_ENDPOINT: '/api/v1/fl-insights',
  })

  initFaro({
    // Preview deployments and gatsby develop must not report as production
    disabled:
      process.env.NODE_ENV !== 'production' ||
      globalThis.location.hostname.endsWith('.vercel.app'),
    serviceName: 'debacode-website',
    host: '/api/v1/fl-observability',
    token: process.env.GATSBY_FARO_TOKEN,
    environment: 'production',
    ignoreUrls: [OBSERVABILITY_PATTERN, INSIGHTS_PATTERN],
    propagateTraceHeaderCorsUrls: [globalThis.location.origin],
    ignoreErrors: DEFAULT_IGNORE_ERRORS,
    botPatterns: DEFAULT_BOT_PATTERNS,
    beforeSend: createBeforeSendRedactor({
      sensitiveParamNames: DEFAULT_SENSITIVE_PARAM_NAMES,
    }),
  })
}

/**
 * Names the Faro view after the matched page, not the URL. Unknown URLs render
 * the 404 page, whose page path stays `/404.html`.
 */
export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
  props,
}) => {
  const { page } = props.pageResources

  return (
    <>
      <FaroRouteView route={page.matchPath ?? page.path} />
      {element}
    </>
  )
}

// biome-ignore lint/performance/noBarrelFile: tech-debt
export { wrapPageElement as wrapRootElement } from './gatsby-ssr'
